import { useEffect } from "react"

import {
  Schedule,
  useAccount,
  useLayerPopupContext,
  useSchedule,
} from "@shared/contexts"
import { getRef } from "@shared/modules"
import { streamerService } from "@shared/services"

export default function useWatchingSchedule() {
  const { schedule, setSchedule } = useSchedule()
  const { account } = useAccount()
  const { open } = useLayerPopupContext()

  const viewerRole = account.viewer?.role

  const scheduleKey = schedule?.key

  useEffect(() => {
    if (!scheduleKey || !viewerRole) return

    const scheduleRef = getRef("schedules").child(scheduleKey)

    scheduleRef.on(
      "child_changed",
      (snapshot: firebase.database.DataSnapshot) => {
        switch (snapshot.key) {
          case "streaming_username":
            if (viewerRole) {
              streamerService.changeStreamingUrl(viewerRole, snapshot.val())
            }

            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              streamingUsername: snapshot.val(),
            }))
            break
          case "streaming_url":
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              streamingUrl: snapshot.val(),
            }))
            break
          case "mobile_streaming_url":
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              mobileStreamingUrl: snapshot.val(),
            }))
            break
          case "stream_key":
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              streamKey: snapshot.val(),
            }))
            break
          case "schedule_status":
            if (viewerRole && snapshot.val() === "END") {
              streamerService.liveClosed(viewerRole)
            }
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              scheduleStatus: snapshot.val(),
            }))
            break
          case "streaming_status":
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              streamingStatus: snapshot.val(),
            }))
            break
          case "is_emoticon":
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              isEmoticon: snapshot.val(),
            }))
            break
          case "is_congrats_message":
            setSchedule((prevSchedule: Schedule | null) => ({
              ...prevSchedule!,
              isCongratsMessage: snapshot.val(),
            }))
            break
          default:
            break
        }
      },
    )

    const blacklistChatRef = getRef("blacklist_chats")
      .child(scheduleKey)
      .child(viewerRole)

    blacklistChatRef.on("value", (snapshot: firebase.database.DataSnapshot) => {
      setSchedule((prevSchedule: Schedule | null) => ({
        ...prevSchedule!,
        isActivateBlockChat: snapshot.val(),
      }))
    })

    return () => {
      scheduleRef.off("child_changed")
      blacklistChatRef.off("value")
    }
  }, [viewerRole, scheduleKey, setSchedule])

  useEffect(() => {
    if (!schedule) return

    if (schedule.scheduleStatus === "END") {
      open("LIVE_END_VOD")
      return
    }
  }, [schedule, open])
}
